import React from 'react';
import { Link } from 'react-router-dom';
import './Public.css';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export default function EventCard({ event }) {
  const start = event.next_date ? new Date(event.next_date) : null;
  const end   = event.last_date ? new Date(event.last_date) : null;
  const multiDay = start && end && start.toDateString() !== end.toDateString();

  const rangeLabel = () => {
    if (!start) return 'Date TBA';
    const fmt = (d) => `${d.getDate()} ${MONTHS[d.getMonth()]}`;
    if (multiDay) return `${fmt(start)} – ${fmt(end)} ${end.getFullYear()}`;
    return `${start.toLocaleDateString('en-GB', { weekday: 'short' })}, ${fmt(start)} ${start.getFullYear()}`;
  };

  return (
    <Link to={`/events/${event.slug}`} className="evt-card">
      <div className="evt-card-media">
        {event.image_url
          ? <img src={'https://testapi.aiworldcommunity.com' + event.image_url} alt={event.title} loading="lazy" />
          : <div className="evt-card-media-ph"><span>{event.title?.[0] || 'E'}</span></div>}
        {start && (
          <div className="evt-card-date-chip">
            <div className="d">{start.getDate()}</div>
            <div className="m">{MONTHS[start.getMonth()]}</div>
          </div>
        )}
        <div className={`evt-card-price ${event.is_free ? 'free' : ''}`}>
          {event.is_free ? 'FREE' : `${event.currency} ${parseFloat(event.price || 0).toFixed(0)}`}
        </div>
      </div>
      <div className="evt-card-body">
        <div className="evt-card-tags">
          <span className="evt-tag">{event.venue_type === 'Online' ? '💻 Online' : event.venue_type === 'Physical' ? '📍 In-person' : '🌐 Hybrid'}</span>
          {multiDay && <span className="evt-tag range">Multi-day</span>}
        </div>
        <h3 className="evt-card-title">{event.title}</h3>
        <p className="evt-card-desc">
          {event.description ? `${event.description.slice(0, 96)}${event.description.length > 96 ? '…' : ''}` : rangeLabel()}
        </p>
        <div className="evt-card-foot">
          <span className="evt-card-attendees">📅 {rangeLabel()}</span>
          <span className="evt-card-cta">Details →</span>
        </div>
      </div>
    </Link>
  );
}
